import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';  // Import NavLink instead of Link
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserDoctor, faBars, faTimes, faHome, faBedPulse } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(true);  // State to manage whether sidebar is open or collapsed

    const toggleSidebar = () => {
        setIsOpen(!isOpen);  // Toggle between true and false
    };

    return (
        <div className={`bg-white text-dark min-vh-100 d-flex flex-column shadow ${isOpen ? 'p-3' : 'p-2'}`} style={{ width: isOpen ? '250px' : '80px', transition: 'width 0.3s ease', zIndex: '99' }}>
            <div className={`d-flex ${isOpen ? 'justify-content-end' : 'justify-content-center'}`}>
                <button onClick={toggleSidebar} className="btn btn-light">
                    <FontAwesomeIcon icon={isOpen ? faTimes : faBars} />
                </button>
            </div>

            <div className="d-flex justify-content-center align-items-center mb-4 border-bottom pb-5">
                {isOpen && (
                    <img
                        src="/logo.png"
                        alt="Logo"
                        className="w-50"
                    />
                )}
            </div>

            {/* Sidebar links */}
            <ul className="nav flex-column mt-4">
                <li className="nav-item mb-3">
                    <NavLink
                        to="/dashboard"
                        className={`nav-link fs-5 d-flex align-items-center ${isOpen ? 'justify-content-start' : 'justify-content-center'}`}
                        style={({ isActive }) => ({
                            color: isActive ? '#ffffff' : '#000000',
                            backgroundColor: isActive ? '#449998' : 'transparent',
                            borderRadius: '4px',
                            padding: '10px',
                        })}
                    >
                        <FontAwesomeIcon icon={faHome} className={`${isOpen ? 'me-2' : 'mx-auto'}`} />
                        {isOpen && <span>Dashboard</span>}
                    </NavLink>
                </li>
                <li className="nav-item mb-3">
                    <NavLink
                        to="/doctors"
                        className={`nav-link fs-5 d-flex align-items-center ${isOpen ? 'justify-content-start' : 'justify-content-center'}`}
                        style={({ isActive }) => ({
                            color: isActive ? '#ffffff' : '#000000',
                            backgroundColor: isActive ? '#449998' : 'transparent',
                            borderRadius: '4px',
                            padding: '10px',
                        })}
                    >
                        <FontAwesomeIcon icon={faUserDoctor} className={`${isOpen ? 'me-2' : 'mx-auto'}`} />
                        {isOpen && <span>Doctors</span>}
                    </NavLink>
                </li>
                <li className="nav-item mb-3">
                    <NavLink
                        to="/patients"
                        className={`nav-link fs-5 d-flex align-items-center ${isOpen ? 'justify-content-start' : 'justify-content-center'}`}
                        style={({ isActive }) => ({
                            color: isActive ? '#ffffff' : '#000000',
                            backgroundColor: isActive ? '#449998' : 'transparent',
                            borderRadius: '4px',
                            padding: '10px',
                        })}
                    >
                        <FontAwesomeIcon icon={faBedPulse} className={`${isOpen ? 'me-2' : 'mx-auto'}`} />
                        {isOpen && <span>Patients</span>}
                    </NavLink>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;
